import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  // TODO: Deprecated - only used by legacy lessons/review.html.erb. Remove when migrated to UI::Accordion.
  static targets = ['body']

  // TODO: Deprecated - only used by legacy lessons/review.html.erb. Remove when migrated to UI::Accordion.
  toggle() {
    this.bodyTarget.classList.toggle('hidden')
  }

  // First-paint state restoration lives in an inline <script> inside the
  // ui/accordion component template — Stimulus's connect() runs after paint, so
  // doing it here would cause a flash. We still call restoreState() here as a
  // safety net for re-connections (e.g. Stimulus reattaching after a partial
  // update) where the inline script doesn't re-execute.
  connect() {
    this.id = this.element.dataset.accordionId

    if (!this.id) return

    this.restoreState()
    this.element.addEventListener('toggle', this.saveState)
    document.addEventListener('turbo:render', this.restoreState)
  }

  disconnect() {
    this.element.removeEventListener('toggle', this.saveState)
    document.removeEventListener('turbo:render', this.restoreState)
  }

  saveState = () => {
    const isOpen = this.element.open
    sessionStorage.setItem(`accordion-${this.id}`, isOpen)
  }

  restoreState = () => {
    const isOpen = sessionStorage.getItem(`accordion-${this.id}`)
    if (isOpen === 'true') {
      this.element.open = true
    } else if (isOpen === 'false') {
      this.element.open = false
    }
  }
}
